// extracted by mini-css-extract-plugin
export default {"editor":"FormTinyMceEditor-module_editor__dt_nbk"};